<template>
    <div :class="`as-goals-scored`">
        <div class="as-goals-scored__head">
            <IconCard />
            <IconCard fill="#B81616"/>
            <span> Thẻ (Hiệp 1/2)  </span>
        </div>
        <div class="as-history">
            <div class="as-history-item">
                <div class="as-history-item__head">
                    <div class="as-head-tab" :class="{ 'as-active': activeTab === 'all' }" @click="setActiveTab('all')">
                        Trung bình hiệp 1/2
                    </div>
                    <div class="as-head-tab" :class="{ 'as-active': activeTab === 'half' }" @click="setActiveTab('half')">
                        Trên 0.5 ~ 3
                    </div>
                </div>
                <div class="as-history-item__body">
                    <div class="as-competition" v-if="activeTab === 'all'">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Thẻ H1/H2</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">AVG</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>TB TS thẻ H1</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'ts_h1'))}`">{{ getValueWithMode('home', 'ts_h1') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'ts_h1'))}`">{{ getValueWithMode('away', 'ts_h1') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'ts_h1'), getValueWithMode('away', 'ts_h1')))}`">{{ calculatorAVG(getValueWithMode('home', 'ts_h1'), getValueWithMode('away', 'ts_h1')) }}</td>
                                </tr>
                                <tr>
                                    <td>TB TS thẻ H2</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'ts_h2'))}`">{{ getValueWithMode('home', 'ts_h2') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'ts_h2'))}`">{{ getValueWithMode('away', 'ts_h2') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'ts_h2'), getValueWithMode('away', 'ts_h2')))}`">{{ calculatorAVG(getValueWithMode('home', 'ts_h2'), getValueWithMode('away', 'ts_h2')) }}</td>
                                </tr>
                                <tr>
                                    <td>Thẻ TB H1</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'tb_h1'))}`">{{ getValueWithMode('home', 'tb_h1') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'tb_h1'))}`">{{ getValueWithMode('away', 'tb_h1') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'tb_h1'), getValueWithMode('away', 'tb_h1')))}`">{{ calculatorAVG(getValueWithMode('home', 'tb_h1'), getValueWithMode('away', 'tb_h1')) }}</td>
                                </tr>
                                <tr>
                                    <td>Thẻ TB H2</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'tb_h2'))}`">{{ getValueWithMode('home', 'tb_h2') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', 'tb_h2'))}`">{{ getValueWithMode('away', 'tb_h2') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', 'tb_h2'), getValueWithMode('away', 'tb_h2')))}`">{{ calculatorAVG(getValueWithMode('home', 'tb_h2'), getValueWithMode('away', 'tb_h2')) }}</td>
                                </tr>
                                <!-- <tr>
                                    <td>Thẻ TB H2</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85Corners_overall'))}`"><IconPadlock/></td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85Corners_overall'))}`"><IconPadlock/></td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', 'over85Corners_overall'))}`"><IconPadlock/></td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                    <div class="as-competition" v-if="activeTab === 'half'">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Thẻ H1/H2</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">AVG</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1H Over 0.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '1h_over_05'))}`">{{ getValueWithMode('home', '1h_over_05') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '1h_over_05'))}`">{{ getValueWithMode('away', '1h_over_05') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '1h_over_05'), getValueWithMode('away', '1h_over_05')))}`">{{ calculatorAVG(getValueWithMode('home', '1h_over_05'), getValueWithMode('away', '1h_over_05')) }}</td>
                                </tr>
                                <tr>
                                    <td>2H Over 0.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '2h_over_05'))}`">{{ getValueWithMode('home', '2h_over_05') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '2h_over_05'))}`">{{ getValueWithMode('away', '2h_over_05') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '2h_over_05'), getValueWithMode('away', '2h_over_05')))}`">{{ calculatorAVG(getValueWithMode('home', '2h_over_05'), getValueWithMode('away', '2h_over_05')) }}</td>
                                </tr>
                                <tr>
                                    <td>1H Total Under 2</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '1h_total_under_2'))}`">{{ getValueWithMode('home', '1h_total_under_2') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '1h_total_under_2'))}`">{{ getValueWithMode('away', '1h_total_under_2') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2')))}`">{{ calculatorAVG(getValueWithMode('home', '1h_total_under_2'), getValueWithMode('away', '1h_total_under_2')) }}</td>
                                </tr>
                                <tr>
                                    <td>2H Total Under 2</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '2h_total_under_2'))}`">{{ getValueWithMode('home', '2h_total_under_2') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '2h_total_under_2'))}`">{{ getValueWithMode('away', '2h_total_under_2') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2')))}`">{{ calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2')) }}</td>
                                </tr>
                                <tr>
                                    <td>1H is 2~3 Total</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '1h_total_23'))}`">{{ getValueWithMode('home', '1h_total_23') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '1h_total_23'))}`">{{ getValueWithMode('away', '1h_total_23') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '1h_total_23'), getValueWithMode('away', '1h_total_23')))}`">{{ calculatorAVG(getValueWithMode('home', '1h_total_23'), getValueWithMode('away', '1h_total_23')) }}</td>
                                </tr>
                                <tr>
                                    <td>2H is 2~3 Total</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '2h_total_23'))}`">{{ getValueWithMode('home', '2h_total_23') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '2h_total_23'))}`">{{ getValueWithMode('away', '2h_total_23') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '2h_total_23'), getValueWithMode('away', '2h_total_23')))}`">{{ calculatorAVG(getValueWithMode('home', '2h_total_23'), getValueWithMode('away', '2h_total_23')) }}</td>
                                </tr>
                                <tr>
                                    <td>1H Total Over 3</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '1h_total_over_3'))}`">{{ getValueWithMode('home', '1h_total_over_3') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '1h_total_over_3'))}`">{{ getValueWithMode('away', '1h_total_over_3') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '1h_total_over_3'), getValueWithMode('away', '1h_total_over_3')))}`">{{ calculatorAVG(getValueWithMode('home', '1h_total_over_3'), getValueWithMode('away', '1h_total_over_3')) }}</td>
                                </tr>
                                <tr>
                                    <td>2H Total Over 3</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', '2h_total_over_3'))}`">{{ getValueWithMode('home', '2h_total_over_3') }}</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', '2h_total_over_3'))}`">{{ getValueWithMode('away', '2h_total_over_3') }}</td>
                                    <td :class="`as-center ${getClassForItem(calculatorAVG(getValueWithMode('home', '2h_total_over_3'), getValueWithMode('away', '2h_total_over_3')))}`">{{ calculatorAVG(getValueWithMode('home', '2h_total_over_3'), getValueWithMode('away', '2h_total_over_3')) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconCard from '~src/components/icons/foot_stats/IconCard.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';
import { getClassForItem } from '~src/helpers/footystats';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const getValueWithMode = (team = 'home', mode = 'btts', half = 1) => {
        const __data: IStatsParent | null =
            props.footyStats
                ? (team === 'home'
                    ? props.footyStats.home_team_last_x
                    : props.footyStats.away_team_last_x)
                : null;
        let __number = 0;
        if(!__data || !__data.stats || !__data.stats.additional_info){
            return 0;
        }

        const additional_info = __data.stats.additional_info;

        if(__data){
            switch(mode){
                case 'ts_h1':
                    __number = additional_info?.fh_cards_for_overall ?? 0;
                    break;
                case 'ts_h2':
                    __number = additional_info['2h_cards_for_overall'] as number ?? 0;
                    break;
                case 'tb_h1':
                    __number = additional_info?.fh_cards_total_overall ?? 0;
                    break;
                case 'tb_h2':
                    __number = additional_info['2h_cards_total_overall'] as number ?? 0;
                    break;

                case '1h_over_05':
                    __number = additional_info?.fh_cards_for_over05_percentage_overall ?? 0;
                    break;
                case '2h_over_05':
                    __number = additional_info['2h_cards_for_over05_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_under_2':
                    __number = additional_info?.fh_total_cards_under2_percentage_overall ?? 0;
                    break;
                case '2h_total_under_2':
                    __number = additional_info['2h_total_cards_under2_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_23':
                    __number = additional_info?.fh_total_cards_2to3_percentage_overall ?? 0;
                    break;
                case '2h_total_23':
                    __number = additional_info['2h_total_cards_2to3_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_over_3':
                    __number = additional_info?.fh_total_cards_over3_percentage_overall ?? 0;
                    break;
                case '2h_total_over_3':
                    __number = additional_info['2h_total_cards_over3_percentage_overall'] as number ?? 0;
                    break;
            }
        }


        return __number
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }

</script>

<script lang="ts">
export default {};
</script>
